<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="4" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Asistencia</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="4" md="4" lg="12" xxl="12">
                <CInput
                  label="Desde"
                  type="date"
                  aria-label="shift_date"
                  @input="mtd_data"
                  size="sm"
                  id="init"
                  v-model="filter_init"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol xs="12" sm="12" md="12" lg="8" xl="9">
        <CCard>
          <CCardHeader class="d-flex justify-content-between align-items-center">
            <b><i class="fas fa-coins"></i>&nbsp;Lista de Asistencia</b>
            <CButton color="secondary" size="sm" @click="mtdBack">
              <i class="fas fa-arrow-left"></i> Volver
            </CButton>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              :items="data"
              :fields="fields"
              hover
              :striped="true"
              :border="true"
              small
              fixed
              size="md"
            >
              <!-- Badge de estado -->
              <template #state="{ item }">
                <td>
                  <CBadge :color="item.state_color">{{ item.state_label }}</CBadge>
                </td>
              </template>

              <!-- Minutos tardanza -->
              <template #minutos_tardanza="{ item }">
                <td class="text-center">
                  <span v-if="item.minutos_tardanza > 0" class="text-danger font-weight-bold">
                    {{ item.minutos_tardanza }} min
                  </span>
                  <span v-else class="text-muted">—</span>
                </td>
              </template>

              <!-- Salida anticipada -->
              <template #minutos_salida_anticipada="{ item }">
                <td class="text-center">
                  <span v-if="item.minutos_salida_anticipada > 0" style="color: #e67e22;" class="font-weight-bold">
                    {{ item.minutos_salida_anticipada }} min
                  </span>
                  <span v-else class="text-muted">—</span>
                </td>
              </template>

              <!-- Horas extra -->
              <template #minutos_extra="{ item }">
                <td class="text-center">
                  <span v-if="item.minutos_extra > 0" class="text-success font-weight-bold">
                    {{ item.minutos_extra }} min
                  </span>
                  <span v-else class="text-muted">—</span>
                </td>
              </template>

              <!-- Minutos pendientes -->
              <template #minutos_pendientes="{ item }">
                <td class="text-center">
                  <span v-if="item.minutos_pendientes > 0" class="text-warning font-weight-bold">
                    {{ item.minutos_pendientes }} min
                  </span>
                  <span v-else-if="item.minutos_tardanza > 0 || item.minutos_salida_anticipada > 0" class="text-success">
                    <i class="fas fa-check"></i> Recuperado
                  </span>
                  <span v-else class="text-muted">—</span>
                </td>
              </template>

              <!-- Acciones -->
              <template #acciones="{ item }">
                <td class="text-center">
                  <CButton
                    v-if="item.minutos_pendientes > 0"
                    color="warning"
                    size="sm"
                    @click="mtd_open_recovery(item)"
                    v-c-tooltip="'Registrar recuperación'"
                  >
                    <i class="fas fa-clock"></i>
                  </CButton>
                  <CButton
                    v-if="item.state === 2 || item.minutos_salida_anticipada > 0"
                    color="info"
                    size="sm"
                    class="ml-1"
                    @click="mtd_open_historial(item)"
                    v-c-tooltip="'Ver historial de recuperaciones'"
                  >
                    <i class="fas fa-history"></i>
                  </CButton>
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <!-- Modal: Registrar recuperación -->
    <CModalForm
      :show.sync="modal_recovery.show"
      :title="`Registrar recuperación — ${modal_recovery.barber_name}`"
      color="warning"
      :size="'md'"
      :centered="true"
    >
      <CRow>
        <!-- Resumen de deuda -->
        <CCol sm="12" class="mb-2">
          <div class="d-flex flex-wrap" style="gap: 12px;">
            <div v-if="modal_recovery.minutos_tardanza > 0" class="text-center px-3 py-2 rounded" style="background:#fff3cd; min-width:110px;">
              <div class="text-muted" style="font-size:11px;">Tardanza entrada</div>
              <div class="font-weight-bold text-danger">{{ modal_recovery.minutos_tardanza }} min</div>
            </div>
            <div v-if="modal_recovery.minutos_salida_anticipada > 0" class="text-center px-3 py-2 rounded" style="background:#fdebd0; min-width:110px;">
              <div class="text-muted" style="font-size:11px;">Salida anticipada</div>
              <div class="font-weight-bold" style="color:#e67e22;">{{ modal_recovery.minutos_salida_anticipada }} min</div>
            </div>
            <div class="text-center px-3 py-2 rounded" style="background:#f8d7da; min-width:110px;">
              <div class="text-muted" style="font-size:11px;">Total pendiente</div>
              <div class="font-weight-bold text-danger">{{ modal_recovery.minutos_pendientes }} min</div>
            </div>
          </div>
        </CCol>

        <CCol sm="12" md="12" lg="6" xlg="6">
          <CInput
            label="Fecha de recuperación"
            type="date"
            size="sm"
            v-model="modal_recovery.fecha_recuperacion"
          />
        </CCol>
        <CCol sm="12" md="12" lg="6" xlg="6">
          <CInput
            label="Minutos a recuperar"
            type="number"
            size="sm"
            :min="1"
            :max="modal_recovery.minutos_pendientes"
            v-model.number="modal_recovery.minutos_recuperados"
          />
          <small class="text-muted">Máximo: {{ modal_recovery.minutos_pendientes }} min</small>
        </CCol>
        <CCol sm="12" md="12" lg="12" xlg="12" class="mt-2">
          <CTextarea
            label="Observación (opcional)"
            size="sm"
            rows="2"
            v-model="modal_recovery.observacion"
          />
        </CCol>
      </CRow>

      <template #footer>
        <CButton color="secondary" size="sm" @click="modal_recovery.show = false">
          Cancelar
        </CButton>
        <CButton color="warning" size="sm" :disabled="modal_recovery.loading" @click="mtd_store_recovery">
          <span v-if="modal_recovery.loading">
            <i class="fas fa-spinner fa-spin"></i> Guardando...
          </span>
          <span v-else>
            <i class="fas fa-save"></i> Guardar
          </span>
        </CButton>
      </template>
    </CModalForm>

    <!-- Modal: Historial de recuperaciones -->
    <CModalForm
      :show.sync="modal_historial.show"
      :title="`Historial — ${modal_historial.barber_name}`"
      color="info"
      :size="'lg'"
      :centered="true"
    >
      <div v-if="modal_historial.loading" class="text-center py-3">
        <i class="fas fa-spinner fa-spin fa-2x"></i>
      </div>
      <div v-else>
        <!-- Resumen: 5 bloques -->
        <CRow class="mb-3 text-center">
          <CCol sm="12" md="" lg="" class="mb-2">
            <div class="text-muted small">Tardanza entrada</div>
            <div class="font-weight-bold text-danger">{{ modal_historial.assist.minutos_tardanza }} min</div>
          </CCol>
          <CCol sm="12" md="" lg="" class="mb-2">
            <div class="text-muted small">Sal. anticipada</div>
            <div class="font-weight-bold" style="color:#e67e22;">{{ modal_historial.assist.minutos_salida_anticipada ?? 0 }} min</div>
          </CCol>
          <CCol sm="12" md="" lg="" class="mb-2">
            <div class="text-muted small">Horas extra</div>
            <div class="font-weight-bold text-success">{{ modal_historial.assist.minutos_extra ?? 0 }} min</div>
          </CCol>
          <CCol sm="12" md="" lg="" class="mb-2">
            <div class="text-muted small">Recuperados</div>
            <div class="font-weight-bold text-info">{{ modal_historial.assist.minutos_recuperados }} min</div>
          </CCol>
          <CCol sm="12" md="" lg="" class="mb-2">
            <div class="text-muted small">Pendientes</div>
            <div class="font-weight-bold text-warning">{{ modal_historial.assist.minutos_pendientes }} min</div>
          </CCol>
        </CRow>

        <!-- Tabla de recuperaciones -->
        <div v-if="modal_historial.recoveries.length === 0" class="text-center text-muted py-3">
          No hay recuperaciones registradas aún.
        </div>
        <CDataTable
          v-else
          :items="modal_historial.recoveries"
          :fields="fields_historial"
          small
          border
          striped
        >
          <template #acciones="{ item }">
            <td class="text-center">
              <CButton
                color="danger"
                size="sm"
                @click="mtd_destroy_recovery(item.Id)"
                v-c-tooltip="'Eliminar recuperación'"
              >
                <i class="fas fa-trash"></i>
              </CButton>
            </td>
          </template>
        </CDataTable>
      </div>

      <template #footer>
        <CButton color="secondary" size="sm" @click="modal_historial.show = false">
          Cerrar
        </CButton>
      </template>
    </CModalForm>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import CModalForm from "../../../components/shared/modals/cModalForm.vue";

const fields = [
  { key: "index",                    label: "#",            _style: "width:3%" },
  { key: "name",                     label: "Personal",     _style: "width:18%" },
  { key: "date_init",                label: "Entrada",      _style: "width:14%" },
  { key: "date_end",                 label: "Salida",       _style: "width:14%" },
  { key: "state",                    label: "Estado",       _style: "width:9%" },
  { key: "minutos_tardanza",         label: "Tardanza",     _style: "width:9%" },
  { key: "minutos_salida_anticipada",label: "Sal. Antic.",  _style: "width:9%" },
  { key: "minutos_extra",            label: "Hs. Extra",    _style: "width:9%" },
  { key: "minutos_pendientes",       label: "Pendiente",    _style: "width:9%" },
  { key: "acciones",                 label: "Acciones",     _style: "width:9%" },
];

const fields_historial = [
  { key: "fecha_recuperacion",  label: "Fecha" },
  { key: "minutos_recuperados", label: "Minutos" },
  { key: "observacion",         label: "Observación" },
  { key: "acciones",            label: "",           _style: "width:5%" },
];

const STATE_LABELS = {
  0: { label: "Falta",       color: "danger"  },
  1: { label: "Asistencia",  color: "success" },
  2: { label: "Tardanza",    color: "warning" },
  3: { label: "Justificado", color: "info"    },
};

export default {
  components: { CModalForm },
  data() {
    return {
      prefix: "assists",
      prefix_recovery: "assistRecovery",
      fields,
      fields_historial,
      data: [],
      filter_init: null,

      modal_recovery: {
        show:                       false,
        loading:                    false,
        assist_id:                  null,
        barber_id:                  null,
        barber_name:                "",
        minutos_tardanza:           0,
        minutos_salida_anticipada:  0,
        minutos_pendientes:         0,
        fecha_recuperacion:         null,
        minutos_recuperados:        null,
        observacion:                "",
      },

      modal_historial: {
        show:        false,
        loading:     false,
        assist_id:   null,
        barber_name: "",
        assist: {
          minutos_tardanza:          0,
          minutos_salida_anticipada: 0,
          minutos_extra:             0,
          minutos_recuperados:       0,
          minutos_pendientes:        0,
        },
        recoveries: [],
      },
    };
  },

  created() {
    moment.locale("es");
    this.filter_init = moment().format("YYYY-MM-DD");
    this.mtd_data();
  },

  methods: {
    ...mapActions(["get", "post"]),

    mtdBack() {
      this.$emit("mtdBack");
    },

    // ─── Carga principal ───────────────────────────────────────────
    mtd_data() {
      this.post({
        url: `${this.$store.getters.get__url}/${this.prefix}/byAssists`,
        token: this.$store.getters.get__token,
        params: {
          init:       this.filter_init,
          campu_id:   this.$store.getters.get_campu.id,
          company_id: this.$store.getters.get_company.id,
        },
      }).then((response) => {
        if (response.statusCode == 200) {
          const barbers = response.data.user;
          const data    = response.data.data;

          this.data = barbers.map((barber, index) => {
            const record = data.find(item => item.user_id == barber.user_id);
            const state  = record?.state ?? null;

            return {
              index:                     index + 1,
              assist_id:                 record?.id ?? null,
              barber_id:                 barber.id,
              name:                      `${barber.name} ${barber.last_name}`,
              date_init:                 record ? this.formatDateTime(record.date_init) : "",
              date_end:                  record ? (record.date_end ? this.formatDateTime(record.date_end) : "") : "",
              state:                     state,
              state_label:               state !== null ? (STATE_LABELS[state]?.label ?? "—") : "—",
              state_color:               state !== null ? (STATE_LABELS[state]?.color ?? "secondary") : "secondary",
              minutos_tardanza:          record?.minutos_tardanza          ?? 0,
              minutos_salida_anticipada: record?.minutos_salida_anticipada ?? 0,
              minutos_extra:             record?.minutos_extra             ?? 0,
              minutos_pendientes:        record?.minutos_pendientes        ?? 0,
            };
          });
        }
      }).catch(() => {
        Swal.fire({ title: "Error al cargar asistencias", icon: "error" });
      });
    },

    // ─── Abrir modal recuperación ──────────────────────────────────
    mtd_open_recovery(item) {
      this.modal_recovery = {
        show:                       true,
        loading:                    false,
        assist_id:                  item.assist_id,
        barber_id:                  item.barber_id,
        barber_name:                item.name,
        minutos_tardanza:           item.minutos_tardanza,
        minutos_salida_anticipada:  item.minutos_salida_anticipada,
        minutos_pendientes:         item.minutos_pendientes,
        fecha_recuperacion:         moment().format("YYYY-MM-DD"),
        minutos_recuperados:        item.minutos_pendientes, // pre-llena con el máximo
        observacion:                "",
      };
    },

    // ─── Guardar recuperación ──────────────────────────────────────
    mtd_store_recovery() {
      const r = this.modal_recovery;

      if (!r.fecha_recuperacion) {
        Swal.fire({ title: "Ingresa la fecha de recuperación", icon: "warning" });
        return;
      }
      if (!r.minutos_recuperados || r.minutos_recuperados <= 0) {
        Swal.fire({ title: "Ingresa los minutos a recuperar", icon: "warning" });
        return;
      }
      if (r.minutos_recuperados > r.minutos_pendientes) {
        Swal.fire({
          title: `El máximo permitido es ${r.minutos_pendientes} minutos`,
          icon: "warning",
        });
        return;
      }

      r.loading = true;

      this.post({
        url: `${this.$store.getters.get__url}/${this.prefix_recovery}/store`,
        token: this.$store.getters.get__token,
        params: {
          assist_id:           r.assist_id,
          barber_id:           r.barber_id,
          fecha_recuperacion:  r.fecha_recuperacion,
          minutos_recuperados: r.minutos_recuperados,
          observacion:         r.observacion,
        },
      }).then((response) => {
        r.loading = false;
        if (response.statusCode == 200) {
          this.modal_recovery.show = false;
          Swal.fire({ title: "Recuperación registrada", icon: "success", timer: 1500 });
          this.mtd_data();
        } else {
          Swal.fire({ title: response.message ?? "Error al guardar", icon: "error" });
        }
      }).catch(() => {
        r.loading = false;
        Swal.fire({ title: "Error al guardar la recuperación", icon: "error" });
      });
    },

    // ─── Abrir historial ───────────────────────────────────────────
    mtd_open_historial(item) {
      this.modal_historial = {
        show:        true,
        loading:     true,
        assist_id:   item.assist_id,
        barber_name: item.name,
        assist: {
          minutos_tardanza:          0,
          minutos_salida_anticipada: 0,
          minutos_extra:             0,
          minutos_recuperados:       0,
          minutos_pendientes:        0,
        },
        recoveries: [],
      };

      this.get({
        url: `${this.$store.getters.get__url}/${this.prefix_recovery}/byAssist/${item.assist_id}`,
        token: this.$store.getters.get__token,
      }).then((response) => {
        this.modal_historial.loading = false;
        if (response.statusCode == 200) {
          this.modal_historial.assist     = response.data.assist;
          this.modal_historial.recoveries = response.data.recoveries;
        }
      }).catch(() => {
        this.modal_historial.loading = false;
        Swal.fire({ title: "Error al cargar el historial", icon: "error" });
      });
    },

    // ─── Eliminar recuperación ─────────────────────────────────────
    mtd_destroy_recovery(recoveryId) {
      Swal.fire({
        title: "¿Eliminar esta recuperación?",
        text: "Se revertirán los minutos a la asistencia.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (!result.isConfirmed) return;

        this.post({
          url: `${this.$store.getters.get__url}/${this.prefix_recovery}/destroy`,
          token: this.$store.getters.get__token,
          params: { id: recoveryId },
        }).then((response) => {
          if (response.statusCode == 200) {
            this.modal_historial.recoveries = this.modal_historial.recoveries.filter(
              (r) => r.Id !== recoveryId
            );
            this.mtd_open_historial({
              assist_id: this.modal_historial.assist_id,
              name:      this.modal_historial.barber_name,
            });
            this.mtd_data();
          } else {
            Swal.fire({ title: response.message ?? "Error al eliminar", icon: "error" });
          }
        }).catch(() => {
          Swal.fire({ title: "Error al eliminar la recuperación", icon: "error" });
        });
      });
    },

    // ─── Helpers ──────────────────────────────────────────────────
    formatDateTime(dateTime) {
      const date = new Date(dateTime);
      const formattedDate = date.toLocaleDateString("es-ES", {
        day: "2-digit", month: "2-digit", year: "numeric",
      });
      const formattedTime = date.toLocaleTimeString("es-ES", {
        hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
      });
      return `${formattedDate} ${formattedTime}`;
    },
  },
};
</script>

<style lang="scss" scoped></style>